module.exports = __webpack_public_path__ + "img/logotype.1c96b1c3.svg";